// extracted by mini-css-extract-plugin
export default {"card":"Card_card_WnO9z","cardTitle":"Card_cardTitle_kT4MO"};